/* GuardoPro : minuteur « panier reserve » du tiroir.
   Il vivait dans un <script> du gabarit du tiroir ; or Dawn reinjecte ce
   balisage par l'API de rendu de section apres chaque ajout, et un script
   insere par innerHTML ne s'execute pas. D'ou le --:-- fige.
   On le charge donc une fois, et on reaccroche a chaque remplacement. */
(function () {
  if (window.__guardoCartTimer) return;
  window.__guardoCartTimer = true;

  var CLE = 'scd-reserve-end';

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function accroche(bar) {
    if (!bar || bar.dataset.scdOn) return;
    var out = bar.querySelector('[data-scd-reserve-time]');
    if (!out) return;
    bar.dataset.scdOn = '1';

    var fin = null;
    try { fin = parseInt(sessionStorage.getItem(CLE), 10); } catch (e) {}
    if (!fin || isNaN(fin) || fin < Date.now()) {
      fin = Date.now() + (parseInt(bar.dataset.minutes, 10) || 10) * 60000;
      try { sessionStorage.setItem(CLE, String(fin)); } catch (e) {}
    }

    var t = setInterval(bat, 1000);
    function bat() {
      if (!bar.isConnected) { clearInterval(t); return; }
      var reste = Math.max(0, fin - Date.now());
      var s = Math.floor(reste / 1000);
      out.textContent = pad(Math.floor(s / 60)) + ':' + pad(s % 60);
      if (reste <= 0) { clearInterval(t); bar.hidden = true; }
    }
    bat();
  }

  function balaye() {
    document.querySelectorAll('[data-scd-reserve]').forEach(accroche);
  }

  function demarre() {
    balaye();
    var cible = document.querySelector('cart-drawer') || document.body;
    new MutationObserver(balaye).observe(cible, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarre);
  } else { demarre(); }
})();
